import React from 'react';

import styled, { useTheme } from 'styled-components';
import { useIntl, FormattedMessage } from 'react-intl';

import { commonComponentsRegistry } from '../../../registry/CommonRegistry';

const InputColorRaw = commonComponentsRegistry.getLazyComponent('InputColorRaw');

export const Label = styled.label`
    margin-left: 2px;
    margin-right: 2px;
    margin-bottom: 8px;
    font-size: 14px;
    width: 100%;
    min-height: 20px;
`;

export const Fieldset = styled.fieldset`
    margin: 12px 0px !important;
    width: 100% !important;
`;

export const EditorInputColor = ({
    label,
    initialValue,
    handleChange,
}: {
    label: string;
    initialValue?: string;
    handleChange: (color: string) => void;
}) => {
    const theme = useTheme();
    const intl = useIntl();

    const palettes = [
        {
            name: intl.formatMessage({ id: 'GLOBAL_Platform_Color' }),
            colors: [
                theme.color.primary,
                theme.color.secondary,
                theme.color.headerColor,
                theme.color.lavender,
                theme.color.orange,
                theme.color.green,
                theme.color.navy,
                theme.color.overseas,
            ],
        },
    ];

    return (
        <Fieldset>
            <Label>
                <FormattedMessage id={label} />
            </Label>
            <InputColorRaw
                palettes={palettes}
                label={label}
                initialValue={initialValue ?? theme.color.primary}
                name={`background-color`}
                onChange={handleChange}
            />
        </Fieldset>
    );
};
